export default "__VITE_ASSET__97901759__"